export class register_pObj {
    withdrawFromBank: boolean;
    country: string;
    phoneCountryCode: string;
    countryCode: string;
    currencyCode: string;
    emailAddress: string;
    pinNumber: string;
    accountNumber: number;
    firstName: string;
    surname: string;
    idNumber: number;
    address1: string;
    address2: string;
    suburb: string;
    postalCode: number;
    email: string;
    phoneNumber: number;
    agreeToTerms: boolean;
    cardType: string;
    cardNumber: string;
    cardExpireDate: any;
    cardExpireDateMMYY: any;
    cardSecurityCode: any;
    balance: number;
    customerIdType: string;
    customerIdReference: string;
    title:string;
    nicFrontImage: string;
    nicBackImage: string;
}